import styled from "styled-components";
import { Device } from "@pepdirect/v3/styles/screenSizes";
import { colors } from "@pepdirect/v3/styles/variables";
import { SimpleModal } from "@pepdirect/v3/ui/SimpleModal";

export const StyledSimpleModal = styled(SimpleModal)`
  @media ${Device.notMobile} {
    width: unset;
    min-width: 600px;
  }
`;

export const StyledAddress = styled.div`
  background-color: ${colors.gray100};
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  padding: 20px;
  width: 100%;
  border-radius: 6px;
`;

export const StyledAddressTitle = styled.div`
  font-weight: 700;
`;

export const StyledAddressesContainer = styled.div`
  display: flex;
  gap: 20px;

  @media ${Device.mobile} {
    flex-direction: column;
  }
`;

export const StyledButtonContainer = styled.div`
  box-shadow: 0px -1px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding: 24px;

  @media ${Device.mobile} {
    flex-direction: column;
  }
`;

export const StyledMessage = styled.div`
  font-size: 16px;
  padding: 20px 0 24px;
`;

export const StyledModalContainer = styled.div`
  padding: 16px 24px 40px;
`;

export const StyledInvalidZipCodeText = styled.div`
  color: ${colors.gray500};
  margin-top: 8px;
`;

export const StyledBoldText = styled.span`
  font-weight: 700;
`;

export const StyledZip = styled.span`
  color: ${colors.red};
  font-weight: 700;
`;
